module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/sp-theme-1-892fc4686ef2ae14ae3fa1394ee1b6e5.webp";